export default [
    {
        path: 'cancelamento-resultado',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-cancelamento-resultado' */
            '@/views/exame-laboratorial/cancelamento-resultado/Index'
        ),
        redirect: 'cancelamento-resultado/create',
        children: [
            {
                name: 'exame-laboratorial-cancelamento-resultado-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-cancelamento-resultado' */
                    '@/views/exame-laboratorial/cancelamento-resultado/Form.vue'
                ),
            },
        ],
    }
]